<div class="help__container">
    <div mat-dialog-title class="help__header">
        <div class="help__close">
            <mat-icon mat-dialog-close>close</mat-icon>
        </div>
        <img proLogoImg alt="logo" class="content-logo__logo">
        <h2>{{ 'help_modal.title' | translate }}</h2>
    </div>
    <div mat-dialog-content class="help__content">
        <ol>
            <li class="help__text" [innerHTML]="'help_modal.item-01' | translate"></li>
            <li>
                <span>{{ 'help_modal.item-02' | translate }}</span>
                <ol>
                    <li class="help__text" [innerHTML]="'help_modal.item-02a' | translate"></li>
                    <li class="help__text" [innerHTML]="'help_modal.item-02b' | translate"></li>
                </ol>
            </li>
            <li class="help__text" [innerHTML]="'help_modal.item-03' | translate"></li>
        </ol>
        <div class="help__extra">
            <h4>{{ 'help_modal.subtitle' | translate }}</h4>
            <p>{{ 'help_modal.description' | translate }}</p>
            <ol>
                <li class="help__text" [innerHTML]="'help_modal.item-extra-01' | translate"></li>
                <li class="help__text" [innerHTML]="'help_modal.item-extra-02' | translate"></li>
                <li class="help__text" [innerHTML]="'help_modal.item-extra-03' | translate"></li>
            </ol>
        </div>
    </div>
    <div mat-dialog-actions class="help__actions">
        <signaturit-button mat-dialog-close text="{{ 'btn_label_back' | translate }}" type="tertiary" size="md"></signaturit-button>
    </div>
</div>
